import * as React from 'react';
import { styled, applyClassName } from '@glitz/react';

export function normalize<TProps>(Icon: React.FunctionComponent<TProps & {}>) {
  return styled(applyClassName(Icon), {
    display: 'block',
    height: '1.5em',
    width: '1.5em',
  });
}

import homeSvg from './glyphs/home.svg';
export const HomeIcon = normalize(homeSvg);

import cartSvg from './glyphs/cart.svg';
export const CartIcon = normalize(cartSvg);

import chatSvg from './glyphs/chat.svg';
export const ChatIcon = normalize(chatSvg);

import resetSvg from './glyphs/reset.svg';
export const ResetIcon = normalize(resetSvg);

import checkSvg from './glyphs/checkmark.svg';
export const CheckIcon = normalize(checkSvg);

import quoteSvg from './glyphs/quote.svg';
export const QuoteIcon = normalize(quoteSvg);

import chevronDown from './glyphs/chevron-down.svg';
export const ChevronDownIcon = normalize(chevronDown);

import circleSvg from './glyphs/circle.svg';
export const CircleIcon = styled(normalize(circleSvg), { cursor: 'pointer' });

import circleFilledSvg from './glyphs/circle-filled.svg';
export const CircleFilledIcon = normalize(circleFilledSvg);

import lineArrowLeftSvg from './glyphs/line-arrow-left.svg';
export const LineArrowLeft = normalize(lineArrowLeftSvg);

import lineArrowRightSvg from './glyphs/line-arrow-right.svg';
export const LineArrowRight = normalize(lineArrowRightSvg);

import mapPinSvg from './glyphs/map-pin.svg';
export const MapPinIcon = normalize(mapPinSvg);

import furnitureSvg from './glyphs/furniture.svg';
export const FurnitureIcon = normalize(furnitureSvg);

import carpetsSvg from './glyphs/mattor.svg';
export const CarpetsIcon = normalize(carpetsSvg);

import starSvg from './glyphs/star.svg';
export const StarIcon = normalize(starSvg);

export const ChevronRight = styled(ChevronDownIcon, {
  transform: 'rotate(270deg)',
});
export const ChevronLeft = styled(ChevronDownIcon, {
  transform: 'rotate(90deg)',
});

import fileSvg from './glyphs/file.svg';
export const FileIcon = normalize(fileSvg);

import infoSvg from './glyphs/info.svg';
export const InfoIcon = normalize(infoSvg);

import adviceSvg from './glyphs/advice.svg';
export const AdviceIcon = normalize(adviceSvg);

import alertSvg from './glyphs/alert-circle.svg';
export const AlertIcon = normalize(alertSvg);

//My pages icons
import packageSvg from './glyphs/package.svg';
export const PackageIcon = normalize(packageSvg);

import myPageSvg from './glyphs/mypage.svg';
export const MyPageIcon = normalize(myPageSvg);

import logoutSvg from './glyphs/logout.svg';
export const LogoutIcon = normalize(logoutSvg);

import awardSvg from './glyphs/award.svg';
export const AwardIcon = normalize(awardSvg);

import customerServiceSvg from './glyphs/customer-service.svg';
export const CustomerServiceIcon = normalize(customerServiceSvg);

import giftCardSvg from './glyphs/gift-card.svg';
export const GiftCardIcon = normalize(giftCardSvg);

import giftSvg from './glyphs/gift.svg';
export const GiftIcon = normalize(giftSvg);

import returnsSvg from './glyphs/returns.svg';
export const ReturnsIcon = normalize(returnsSvg);

import downLoadSvg from './glyphs/download.svg';
export const DownloadIcon = normalize(downLoadSvg);

import tagSvg from './glyphs/tag.svg';
export const TagIcon = normalize(tagSvg);

import shippingBoxSvg from './glyphs/shipping-box.svg';
export const ShippingBox = normalize(shippingBoxSvg);

import celebration from './glyphs/celebration.svg';
export const CelebrationIcon = normalize(celebration);

//Social Media icons
import facebookSvg from './glyphs/facebook.svg';
export const FacebookIcon = normalize(facebookSvg);

import instagramSvg from './glyphs/instagram.svg';
export const InstagramIcon = normalize(instagramSvg);

import pinterestSvg from './glyphs/pinterest.svg';
export const PinterestIcon = normalize(pinterestSvg);

import linkedinSvg from './glyphs/linkedin.svg';
export const LinkedinIcon = normalize(linkedinSvg);

import radioButtonCheckedSvg from './glyphs/radio-button-checked.svg';
export const RadioButtonChecked = normalize(radioButtonCheckedSvg);

import radioButtonUncheckedSvg from './glyphs/radio-button-unchecked.svg';
export const RadioButtonUnchecked = normalize(radioButtonUncheckedSvg);
